module.exports = __webpack_public_path__ + "img/7d135b9.png";